(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-side-widget"] && !Shopify.designMode) return;
  try {
    function waitForElement(selector, callback) {
      var poops = setInterval(function () {
          if (document.querySelector(selector)) {
              clearInterval(poops);
              callback();
          }
      }, 100);
  }
  

  document.addEventListener("DOMContentLoaded", () => {
    // Create the side widget container
    const sideWidget = document.querySelector(".CP-side-widget");

    // Check if the size chart is present to conditionally add size chart button
    const isSizeChart = !!document.querySelector(".tw-size-chart");
    const sizeChartEvent = document.querySelector(".tw-size-chart")?.getAttribute("onclick");


    /**** Recently Viewed Drawer **/
      // Handler for Recently Viewed button click
      const recentBtn = sideWidget ? sideWidget.querySelector(".CP-recently-viewed") : null;
      if (recentBtn) {
        recentBtn.addEventListener("click", () => {
          document.documentElement.classList.add("CP-rv-open");
          const drawer = document.querySelector(".CP-recentlyViewedDrawer");
          if (!drawer) return;
          const itemsContainer = drawer.querySelector(".CP-items");
          if (!itemsContainer) return;
          itemsContainer.innerHTML = "";

          // Get recently viewed from localStorage or empty array
          const recent = JSON.parse(localStorage.getItem("cp_IT_recentlyViewed") || "[]");

          // Get current product slug from URL
          const currentSlug = window.location.pathname.split("/products/")[1]?.split("/")[0] || "";

          // Filter out current product
          const filteredRecent = recent.filter(item => item.slug !== currentSlug);

          filteredRecent.forEach((item) => {
            // Prepare product data for Quick View button
            const productData = {
              id: item.id || "",
              title: item.title,
              type: item.type || "",
              images: item.images || [item.image],
              variants: item.variants || [
                {
                  price: parseFloat(item.price.replace(/[^0-9.]/g, "")) * 100 || 0,
                },
              ],
              url: `/products/${item.slug}`,
            };

            // Create a product card HTML string
            const productCard = `
              <div class="CP-drawer-product-card">
                <div class="CP-drawer-product-media" key="${item.slug}">
                  <div class="CP-drawer-slide">
                    <img src="${item.image.replace(/(\.(jpg|jpeg|png|webp))/, "_480x$1")}" alt="${item.title || ''}" />
                  </div>
                </div>
                <div class="CP-drawer-product-info">
                  <h2>${item.title}</h2>
                  <div class="CP-drawer-price-info">
                    <span class="money" doubly-currency="INR">${item.price}</span>
                  </div>
                </div>
                <div class="CP-drawer-action-btn">
                  <button class="quick-view" data-product='${JSON.stringify(productData).replace(/'/g, "&#39;")}'>
                    Quick View
                  </button>
                </div>
              </div>
            `;
            itemsContainer.insertAdjacentHTML("beforeend", productCard);
          });

          // Check chip visibility AFTER cards are added
          const chipIcon = document.querySelector(".CP-chip-item.CP-recently-viewed");
          if (chipIcon) {
            const cardCount = itemsContainer.querySelectorAll(".CP-drawer-product-card").length;
            chipIcon.style.display = cardCount > 1 ? "inline-flex" : "none";
          }

          // Open drawer overlay and drawer panel
          drawer.classList.add("open");
          const overlayEl = document.querySelector(".drawer-overlay");
          if (overlayEl) overlayEl.style.display = "block";
        });
      }
      


    /**** Similar Products ****/
      // Create overlay if not already present
      let overlay = document.querySelector(".CP-Similar_overlay");
      if (!overlay) {
          overlay = document.createElement("div");
          overlay.className = "CP-Similar_overlay";
          document.body.appendChild(overlay);
      }
      // Get drawer element, create if it doesn't exist
      let drawer = document.querySelector(".CP-Similar_Drawer");
      // Close drawer function
      const closeDrawer = () => {
          document.body.classList.remove("no-scroll");
          if (drawer) drawer.classList.remove("open");
          overlay.style.display = "none";
      };
      // ATC click
      function attachAtcListeners() {
          const clonedButtons = document.querySelectorAll(
          ".CP-Similar_Drawer .CP-Similar_items .card-product_atcModal"
          );
          clonedButtons.forEach((btn, index) => {
              btn.addEventListener("click", () => {
                  const originalProducts = document.querySelectorAll(
                  "#similar-products > .product.recentproduct .card-product_atcModal"
                  );
                  if (originalProducts[index]) {
                      originalProducts[index].click();
                  }
                  document.body.classList.remove("no-scroll");
                  document.querySelector(".CP-Similar_Drawer").classList.remove("open");
                  document.querySelector(".CP-Similar_overlay").style.display =
                  "none";
              });
          });
      }
      attachAtcListeners();
      // Attach close event handlers.
      const closeBtn = drawer ? drawer.querySelector(".CP-Similar_closeDrawerBtn") : null;
      if (closeBtn) {
        closeBtn.addEventListener("click", closeDrawer);
      }
      overlay.addEventListener("click", closeDrawer);
      // Setup event to open drawer when .CP-similar-product is clicked
      const similarProductBtn = document.querySelector(".CP-chip-item.CP-similar-product");
      if (similarProductBtn) {
          similarProductBtn.addEventListener("click", () => {
              document.body.classList.add("no-scroll");
              if (drawer) drawer.classList.add("open");
              overlay.style.display = "block";
              if (typeof appendProducts === "function") appendProducts();
          });
      }

      /******/
      // Safely remove the element if it exists
      const sizeChartToRemove = document.querySelector('.custom-sidebar + .sizeChartSidebar');
      if (sizeChartToRemove) {
          sizeChartToRemove.remove();
      }
      /******/
      // Handle click of CP-size-chart sticky chip
      const sizeChartBtn = document.querySelector(".CP-chip-item.CP-size-chart");
      if (sizeChartBtn) {
        sizeChartBtn.addEventListener("click", () => {
          if (typeof cpSizeChartRevampOpen === "function" && document.getElementById("cp-sc-revamp-modal")) {
            cpSizeChartRevampOpen();
          } else {
            const newSizeChartTrigger = document.querySelector(".cp-size-chart-revamp-trigger");
            if (newSizeChartTrigger) {
              newSizeChartTrigger.click(); 
            }
          }
        });
      }


    /**** Check More Button Insertion ****/
    var productDetails = document.querySelector(".CP-inner_content");
    var breadcrumb = document.querySelector(".produt-breadcrum_cont a.product-breadcrum_sub.product-breadcrum_sub-col")
                  || document.querySelector(".produt-breadcrum_cont a.product-breadcrum_sub")
                  || document.querySelector(".produt-breadcrum_cont a:last-of-type");
  
    var breadcrumbText = (breadcrumb && breadcrumb.textContent) ? breadcrumb.textContent.trim() : "";
    var breadcrumbHref = (breadcrumb && breadcrumb.getAttribute("href")) ? breadcrumb.getAttribute("href") : "";

    var allCollections = [];
    if (window.productCollections && Array.isArray(window.productCollections)) {
      allCollections = window.productCollections.slice();
    }
    if (breadcrumbHref && breadcrumbText) {
      allCollections.push({ url: breadcrumbHref, title: breadcrumbText });
    }
    allCollections.reverse();

    function normalize(str) {
      return (str || "").toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    }

    function getProductSlug(path) {
      if (!path || typeof path !== "string") return null;
      var match = path.match(/\/products\/([^/?#]+)/);
      return match ? match[1].replace(/-+$/, "").trim() : null;
    }

    function getCleanCollectionSlug(url) {
      if (!url || typeof url !== "string") return "";
      return url.replace(/^\/collections\//, "").replace(/\/$/, "").trim();
    }

    function findClosestCollectionFromSlug(collections) {
      var productSlug = getProductSlug(window.location.pathname || "");
      if (!productSlug || !collections.length) return null;
      var prodType = normalize((window.meta && window.meta.product) ? window.meta.product.type : "");
      var closest = null;
      var highestScore = -1;

      collections.forEach(function (col) {
        if (!col || !col.url) return;
        var colSlug = normalize(getCleanCollectionSlug(col.url));
        var colTitle = normalize(col.title);
        var score = 0;

        if (prodType && (colSlug.includes(prodType) || colTitle.includes(prodType))) score += 1;
        productSlug.split("-").forEach(function (word) {
          if (word && (colSlug.includes(word) || colTitle.includes(word))) score += 1;
        });

        if (score > highestScore) {
          highestScore = score;
          closest = col;
        }
      });
      return closest;
    }

    var bestMatch = findClosestCollectionFromSlug(allCollections);
    var finalHref = (bestMatch && bestMatch.url) || breadcrumbHref;
    var finalTitle = (bestMatch && bestMatch.title) || breadcrumbText;

    if (!finalHref && window.location.pathname.includes('/products/')) {
      finalHref = "/collections/all";
      finalTitle = "Products";
    }

    if (finalHref) {
      var finalLabel = "Check more " + (finalTitle || "Products");
      var checkMoreButton = '<a href="' + finalHref + '" class="CP-check-more-button" >' + finalLabel + '</a>';

      var targetElement = null;
      var insertionPosition = "afterend";

      // 1. First priority: Before Saree PDP Carousel Container
      var sareeCarousel = document.querySelector(".saree-pdp-page .CP-carousel-wrapper.swiper")
                       || document.querySelector(".saree-pdp-page .CP-carousel-wrapper")
                       || document.querySelector(".CP-carousel-wrapper.swiper")
                       || document.querySelector(".CP-carousel-wrapper");

      // 2. Second priority: Style section
      var styleSection = document.querySelector(".how-to-style-wrapper") 
                      || document.querySelector(".section-how-to-style");

      if (sareeCarousel) {
        targetElement = sareeCarousel;
        insertionPosition = "beforebegin";
      } else if (styleSection) {
        targetElement = styleSection;
        insertionPosition = "afterend";
      } else if (productDetails) {
        targetElement = productDetails;
        insertionPosition = "afterend";
      }

      if (targetElement) {
        var existingBtn = document.querySelector(".CP-check-more-button");
        if (!existingBtn) {
          targetElement.insertAdjacentHTML(insertionPosition, checkMoreButton);
        }
      }
    }
  });

  

  waitForElement('custom-quantity-input.cart-quantity', function () {
    // Saree/Garment PDP keep the real +/- stepper (custom-quantity-input)
    // visible everywhere, including the sticky bar (assets/pdp-revamp.css
    // forces .qty-container.hidden visible there) - skip creating this
    // dropdown replacement for it entirely.
    if (document.querySelector(".saree-pdp-page")) return;

    const customQuantityWrapper = document.querySelector("custom-quantity-input.cart-quantity");
    const quantityInput = customQuantityWrapper ? customQuantityWrapper.querySelector("input.quantity__input") : null;

    if (!customQuantityWrapper || !quantityInput) {
        return;
    }

    const currentValue = parseInt(quantityInput.value, 10) || 1;

    const select = document.createElement("select");
    select.className = "custom-quantity-select";
    select.setAttribute("aria-label", "Select quantity");

    for (let i = 1; i <= 10; i++) {
        const option = document.createElement("option");
        option.value = i;
        option.textContent = i;
        if (i === currentValue) option.selected = true;
        select.appendChild(option);
    }

    customQuantityWrapper.parentNode.insertBefore(select, customQuantityWrapper);

    select.addEventListener("change", function (e) {
        quantityInput.value = e.target.value;
        const event = new Event("change", { bubbles: true });
        quantityInput.dispatchEvent(event);
    });

  });




  document.addEventListener("DOMContentLoaded", function () {
    // Saree/Garment PDP already have their own redesigned variant picker
    // (swatch pills) and their own Add to Cart validation
    // (assets/product-form.js's validateVariantSelection(), which blocks
    // submission and shows a proper error the moment Add to Cart is tapped -
    // on both the normal and the sticky bar, since the sticky bar is the
    // same form/button, just repositioned via CSS). Below this point is a
    // separate legacy mobile-sticky pattern that swaps the size swatches for
    // a plain <select> and makes Add to Cart require two taps (reveal the
    // quantity row, then actually submit) - skip all of it here so the
    // sticky bar keeps showing the same stepper + button row as the normal
    // (non-sticky) area, instead of this older dropdown-based layout.
    if (document.querySelector(".saree-pdp-page")) return;

    var variantRadios = document.querySelector("variant-radios");
    var atcContainer = document.querySelector(".CP-atc-qty-container");
    var atcButton = document.querySelector(".ito_atc__button");
    var toggleArrow = document.querySelector(".CP-toggle-arrow");
    var qtyContainer = document.querySelector(".qty-container");
    var priceText = document.querySelector(".CP-atc-price");

    var atcClickCount = 0;
    var radioInputs = [];
    var qtyLabel;

    if (variantRadios) {
      var fieldset = variantRadios.querySelector("fieldset");
      radioInputs = fieldset.querySelectorAll('input[type="radio"][name="Size"]');
      var purchaseButtons = document.querySelector(".purchase-details__buttons");
      qtyLabel = variantRadios.querySelector(".qty-label-size");
      if (qtyLabel) qtyLabel.innerHTML = "select Size:";

      if (!radioInputs.length || !purchaseButtons) return;

      radioInputs.forEach(function (input) {
        input.checked = false;
      });

      var selectSize = document.createElement("select");
      selectSize.className = "custom-size-dropdown";
      selectSize.setAttribute("aria-label", "Select Size");

      var placeholderOption = document.createElement("option");
      placeholderOption.textContent = "Select Size";
      placeholderOption.disabled = true;
      placeholderOption.selected = true;
      placeholderOption.value = "";
      selectSize.appendChild(placeholderOption);

      radioInputs.forEach(function (input) {
        var label = fieldset.querySelector('label[for="' + input.id + '"]');
        var sizeValue = input.value;
        var option = document.createElement("option");
        option.value = sizeValue;
        option.textContent = label ? label.innerText.trim() : sizeValue;
        selectSize.appendChild(option);
      });

      purchaseButtons.insertAdjacentElement("afterend", selectSize);

      function showSizeError() {
        if (!qtyLabel) return;
        qtyLabel.classList.add("CP-error-msg");
        var labels = variantRadios.querySelectorAll("label");
        labels.forEach(function (label) {
          label.classList.add("CP-error");
        });
        qtyLabel.innerHTML = "Please Select Size";
        qtyLabel.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      function clearSizeError(selectedSize) {
        if (!qtyLabel) return;
        qtyLabel.classList.remove("CP-error-msg");
        var labels = variantRadios.querySelectorAll("label");
        labels.forEach(function (label) {
          label.classList.remove("CP-error");
        });
        qtyLabel.innerHTML = "Select Size: " + selectedSize;
      }

      selectSize.addEventListener("change", function (e) {
        var selectedSize = e.target.value;
        radioInputs.forEach(function (input) {
          if (input.value === selectedSize) {
            input.click();
            if (typeof window.appendCheckedSizeToLegend === "function") {
              window.appendCheckedSizeToLegend();
            }
          }
        });
        if (selectedSize) {
          clearSizeError(selectedSize);
        }
      });

      radioInputs.forEach(function (input) {
        input.addEventListener("change", function () {
          if (input.checked) {
            selectSize.value = input.value;
            clearSizeError(input.value);
          }
        });
      });
    }

    // Mobile-only ATC behavior
    if (window.matchMedia("(max-width: 768px)").matches) {
      ["click", "touchend"].forEach(function (eventType) {
        if (!atcButton) return;
        atcButton.addEventListener(
          eventType,
          function (e) {
            var isSticky =
              atcContainer && atcContainer.classList.contains("cp_sticky");
            if (isSticky && atcClickCount === 0) {
              e.preventDefault();
              if (typeof e.stopImmediatePropagation === "function")
                e.stopImmediatePropagation();

              if (toggleArrow) {
                toggleArrow.classList.add("active");
                toggleArrow.classList.remove("hidden");
              }
              if (qtyContainer) {
                qtyContainer.classList.remove("hidden");
              }

              atcClickCount++;
              return;
            }

            var selected =
              radioInputs.length > 0
                ? Array.from(radioInputs).some(function (input) {
                    return input.checked;
                  })
                : true;
            if (variantRadios && !selected) {
              e.preventDefault();
              if (typeof e.stopImmediatePropagation === "function")
                e.stopImmediatePropagation();
              if (qtyLabel) showSizeError();
              return;
            }

            if (priceText) {
              priceText.style.visibility = "hidden";
              setTimeout(function () {
                priceText.style.visibility = "visible";
                if (variantRadios) {
                  var url = new URL(window.location.href);
                  url.searchParams.delete("variant");
                  window.history.replaceState(null, "", url.toString());

                  radioInputs.forEach(function (input) {
                    input.checked = false;
                  });

                  var sizeSelect = document.querySelector(
                    ".custom-size-dropdown"
                  );
                  if (sizeSelect) sizeSelect.value = "";

                  var quantitySelect = document.querySelector(
                    ".custom-quantity-select"
                  );
                  if (quantitySelect) quantitySelect.value = "1";

                  var qtyLabelEl =
                    variantRadios.querySelector(".qty-label-size");
                  if (qtyLabelEl) qtyLabelEl.innerHTML = "select Size:";
                }
              }, 2000);
            }
          },
          { passive: false }
        );
      });

      if (toggleArrow) {
        toggleArrow.addEventListener("click", () => {
          toggleArrow.classList.toggle("active");
          if (qtyContainer) qtyContainer.classList.toggle("hidden");
        });
      }
    }
  });

              
  // Current Currency Sign
  document.addEventListener("click", function (e) {   
    if( e.target.closest('.footer select.currency-switcher') ) {
      const currentCurrencySign = e.target.closest('.footer select.currency-switcher');
      let curntCurnySignVal = "";
      curntCurnySignVal = currentCurrencySign.value;
      currentCurrencySign.addEventListener("change", (e) => {
        curntCurnySignVal = e.target.value;
        console.log("Currency changed:", curntCurnySignVal);
      });
      console.log(e.target.closest('.footer select.currency-switcher').value);

      document.querySelectorAll(".CP-recentlyViewedDrawer .CP-drawer-price-info > span").forEach((el, index) => {
        el.setAttribute("doubly-currency", curntCurnySignVal);
      });
    }

  });


  /**** STICKY ****/
  document.addEventListener("DOMContentLoaded", function () {
    const custom_qty_atc_Container = document.querySelector(".CP-atc-qty-container");
    const customTextContainer = document.querySelector(".qty-label-cont");
    if (!custom_qty_atc_Container || !customTextContainer) return;
    const containerHeight = custom_qty_atc_Container.parentElement.offsetHeight;
    custom_qty_atc_Container.parentElement.style.minHeight = containerHeight + "px";
    function checkVisibility() {
      const rect = customTextContainer.getBoundingClientRect();
      let offset = -110;
      if(window.matchMedia("(min-width: 768px)").matches) {
        offset = -60;
      }
      const inView = rect.top >= 0 + offset && rect.bottom <= window.innerHeight;
      if (inView) {
        custom_qty_atc_Container.classList.remove("cp_sticky");
      } else {
        custom_qty_atc_Container.classList.add("cp_sticky");
      }
    }
    checkVisibility();
    window.addEventListener("scroll", checkVisibility, { passive: true });
    window.addEventListener("resize", checkVisibility);
  });
  } catch(e) { console.error(e); }
})();

})();
